import assetInformationChoicesApi from 'config/api/assetInformationChoices/assetInformationChoices';
import { AssetInformationFilters } from 'config/api/assetInformationChoices/assetInformationChoices.types';
import QUERY_KEYS from 'config/api/QUERY_KEYS';
import table_messages from 'messages/table_messages';
import { DynamicTableFilter } from 'types/TableFilter';

const integrityChangeControlFilter: DynamicTableFilter<AssetInformationFilters> = {
  sectionName: table_messages.assets_filters.integrity_change_control,
  isDynamic: true,
  queryFn: assetInformationChoicesApi.getAssetInformationChoicesForFilters,
  dataParser: ({ integrityChangeControl }) => integrityChangeControl,
  isSingleSelect: false,
  queryKey: QUERY_KEYS.ASSETS_INFORMATION_CHOICES,
};

export default integrityChangeControlFilter;
